<template>
  <PcHome v-if="!isH5" />
  <H5Home v-else />
</template>

<script>
import H5Home from '../components/H5Home.vue'
import PcHome from '../components/PcHome.vue'

export default {
  name: 'Index',
  components: {
    H5Home,
    PcHome,
  },
  data() {
    return {
      isH5: false,
    }
  },
  mounted() {
    this.updateDeviceType()
    window.addEventListener('resize', this.updateDeviceType, { passive: true })
    window.addEventListener('orientationchange', this.updateDeviceType, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDeviceType)
    window.removeEventListener('orientationchange', this.updateDeviceType)
  },
  methods: {
    updateDeviceType() {
      const width = document.documentElement.clientWidth || window.innerWidth || 0
      this.isH5 = width <= 768
    },
  },
}
</script>

<style scoped></style>
